import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";

import { weatherCtx } from "../../utils/hooks/mollierWeatherContext";
import { useSelector } from "react-redux";
import {
  changeOutdoorPoint,
  changeIndoorPoint,
} from "../../actions/summerPointsActions";
import { useDispatch } from "react-redux";

import {
  changeIndoorPointWinter,
  changeOutdoorPointWinter,
} from "../../actions/winterPointsActions";
import { Tooltip, Typography } from "@mui/material";
import { checkPercetage } from "../../utils/validationFunctions";
/*import { makeStyles } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  switchRoot: {
    width: theme.spacing(7), // Adjust the width to your desired size
    height: theme.spacing(3.5), // Adjust the height to your desired size
  },
}));*/

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 78,
  height: 44,
  padding: 12,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    color: "#fff",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(30px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 22 22"><path fill="${encodeURIComponent(
          "#FFFF00"
        )}" d="m6.76 4.84-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7 1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91 1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#EFEFEF",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#000",
    width: 40,
    height: 40,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 22 22"><path fill="${encodeURIComponent(
        "#80CAEF"
      )}" d="M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#80CAEF",
    borderRadius: 20 / 2,
  },
}));

//TREBA PROSLEDITI I SUMMER I WINTER PA IZVRSAVATI U ODNOSU NA TO U KOMPONENTI VREDNOSTI
function ControlPanelExcel({
  handleConfigChange,
  handleAxisChange,
  DBMollier,
}) {
  const [variable1Unit, setVariable1Unit] = React.useState("m3/h");
  const [variable2Unit, setVariable2Unit] = React.useState("m3/h");
  const { chartConfig } = useContext(weatherCtx);
  const airflowUnit = {
    10: "m3/h",
    20: "m3/s",
  };

  const { summerWeather, setSummerWeather } = useContext(weatherCtx);
  const { t } = useTranslation();
  // const classes = useStyles();
  const outdoorPoint = useSelector(
    (state) => state.processPoint.summerPoints[0]
  );
  const indoorPoint = useSelector(
    (state) => state.processPoint.summerPoints
  ).filter((item) => item.process === "indoor")[0];
  const outdoorPointWinter = useSelector(
    (state) => state.winterPoints.winterPoints[0]
  );
  const indoorPointWinter = useSelector(
    (state) => state.winterPoints.winterPoints
  ).filter((item) => item.process === "indoor")[0];

  const [open, setOpen] = React.useState(false);
  const [localOutdoorTemperature, setLocalOutdoorTemperature] = useState(
    outdoorPoint.temperatureDryBulb
  );
  const [localOutdoorRelHumidity, setLocalOutdoorRelHumidity] = useState(
    outdoorPoint.relativeHumidity
  );
  const [localOutdoorAirflow, setLocalOutdoorAirflow] = useState(
    outdoorPoint.airFlowHours
  );
  const [localIndoorTemperature, setLocalIndoorTemperature] = useState(
    indoorPoint.temperatureDryBulb
  );
  const [localIndoorRelHumidity, setLocalIndoorRelHumidity] = useState(
    indoorPoint.relativeHumidity
  );
  const [localIndoorAirflow, setLocalIndoorAirflow] = useState(
    indoorPoint.airFlowHours
  );

  useEffect(() => {
    console.log(
      "Child menja outdoor" + JSON.stringify(outdoorPoint) + localOutdoorAirflow
    );
    console.log(
      "Child menja indoor" + JSON.stringify(indoorPoint) + localIndoorAirflow
    );
    setLocalOutdoorTemperature(
      summerWeather
        ? outdoorPoint.temperatureDryBulb
        : outdoorPointWinter.temperatureDryBulb
    );
    setLocalOutdoorRelHumidity(
      summerWeather
        ? outdoorPoint.relativeHumidity
        : outdoorPointWinter.relativeHumidity
    );
    setLocalOutdoorAirflow(
      summerWeather
        ? outdoorPoint.airFlowHours
        : outdoorPointWinter.airFlowHours
    );
    setLocalIndoorTemperature(
      summerWeather
        ? indoorPoint.temperatureDryBulb
        : indoorPointWinter.temperatureDryBulb
    );
    setLocalIndoorRelHumidity(
      summerWeather
        ? indoorPoint.relativeHumidity
        : indoorPointWinter.relativeHumidity
    );
    setLocalIndoorAirflow(
      summerWeather ? indoorPoint.airFlowHours : indoorPointWinter.airFlowHours
    );
  }, [outdoorPoint, indoorPoint, summerWeather]);

  const dispatch = useDispatch();
  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Allow numbers and negative sign
    if (!/[\d-]/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleIndoorPointChange = (e) => {
    const { name, value } = e.target;
    summerWeather
      ? dispatch(changeIndoorPoint(name, value))
      : dispatch(changeIndoorPointWinter(name, value));
  };
  const handleOutdoorPointChange = (e) => {
    const { name, value } = e.target;
    summerWeather
      ? dispatch(changeOutdoorPoint(name, value))
      : dispatch(changeOutdoorPointWinter(name, value));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    handleConfigChange(event);
    if (event.target.name === "variable1") {
      // setVariable1(event.target.value);
      switch (event.target.value) {
        case 10:
          setVariable1Unit("m3/h");
          break;
        case 20:
          setVariable1Unit("m3/s");
          break;

        default:
          setVariable1Unit("m3/h");
      }
    } else {
      // setVariable2(event.target.value);
      switch (event.target.value) {
        case 10:
          setVariable2Unit("m3/h");
          break;
        case 20:
          setVariable2Unit("m3/s");
          break;

        default:
          setVariable2Unit("m3/h");
      }
    }
  };
  //const [summerWeather, setSummerWeatherSwitch] = React.useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //if (summerPoints !== null && winterPoints !== null)
    setLoading(false);
  }, []);
  return loading ? (
    <div>Ucitavanje</div>
  ) : (
    <Paper
      p={2}
      sx={{
        border: `2px solid ${summerWeather ? "#FFFF00" : "#80CAEF"}`,
      }}
    >
      <Grid
        container
        spacing={1}
        alignItems="center"
        justifyContent="space-evenly"
        direction="row"
      >
        <Grid item xs={12} md={12}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography>
              {summerWeather
                ? t("mollier.summerMode")
                : t("mollier.winterMode")}
            </Typography>

            <Tooltip title={t("mollier.clkToChgMode")}>
              <MaterialUISwitch
                sx={{ m: 2, p: -2 }}
                checked={summerWeather}
                onChange={() => setSummerWeather(!summerWeather)}
              />
            </Tooltip>
          </Box>
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("operatingpoint.summerOutdoorTemperature")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            disabled={DBMollier}
            name="temperatureDryBulb"
            /*value={
                summerWeather
                  ? outdoorPoint.temperatureDryBulb
                  : outdoorPointWinter.temperatureDryBulb
              }*/
            value={localOutdoorTemperature}
            InputProps={{
              endAdornment: <InputAdornment position="end">°C</InputAdornment>,
            }}
            onChange={(e) => {
              setLocalOutdoorTemperature(e.target.value);
            }}
            onBlur={handleOutdoorPointChange}
            onKeyPress={handleKeyPress}
            //onBlur={handleAxisChange}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("operatingpoint.summerIndoorTemperature")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            name="temperatureDryBulb"
            disabled={DBMollier}
            /* value={
                summerWeather
                  ? indoorPoint.temperatureDryBulb
                  : indoorPointWinter.temperatureDryBulb
              }*/
            value={localIndoorTemperature}
            InputProps={{
              endAdornment: <InputAdornment position="end">°C</InputAdornment>,
            }}
            onChange={(e) => {
              setLocalIndoorTemperature(e.target.value);
            }}
            onBlur={handleIndoorPointChange}
            onKeyPress={handleKeyPress}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("operatingpoint.summerOutdoorHumidity")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            name="relativeHumidity"
            disabled={DBMollier}
            /*value={
                summerWeather
                  ? outdoorPoint.relativeHumidity
                  : outdoorPointWinter.relativeHumidity
              }*/
            value={localOutdoorRelHumidity}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            onChange={(e) => {
              checkPercetage(e.target.value)
                ? setLocalOutdoorRelHumidity(e.target.value)
                : setLocalOutdoorRelHumidity(50);
            }}
            onBlur={handleOutdoorPointChange}
            onKeyPress={handleKeyPress}
            //onBlur={handleAxisChange}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("operatingpoint.summerIndoorHumidity")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            name="relativeHumidity"
            disabled={DBMollier}
            /* value={
                summerWeather
                  ? indoorPoint.relativeHumidity
                  : indoorPointWinter.relativeHumidity
              }*/
            value={localIndoorRelHumidity}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            onChange={(e) => {
              checkPercetage(e.target.value)
                ? setLocalIndoorRelHumidity(e.target.value)
                : setLocalIndoorRelHumidity(50);
            }}
            onBlur={handleIndoorPointChange}
            onKeyPress={handleKeyPress}
            //onBlur={handleAxisChange}
          />
        </Grid>

        <Grid item xs={5}>
          <TextField
            label={t("mollier.outdoorAirflow")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            name="airFlowHours"
            disabled //={DBMollier}
            /* value={
                summerWeather
                  ? outdoorPoint.airFlowHours
                  : outdoorPointWinter.airFlowHours
              }*/
            value={
              summerWeather
                ? outdoorPoint.airFlowHours
                : outdoorPointWinter.airFlowHours
            }
            onChange={(e) => {
              setLocalOutdoorAirflow(e.target.value);
            }}
            onBlur={handleOutdoorPointChange}
            onKeyPress={handleKeyPress}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/*airflowUnit[chartConfig.airflowUnit]*/} m3/h
                </InputAdornment>
              ),
            }}

            //onBlur={handleAxisChange}
          />
        </Grid>

        <Grid item xs={5}>
          <TextField
            label={t("mollier.indoorAirflow")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            name="airFlowHours"
            disabled //={DBMollier}
            /*value={
                summerWeather
                  ? indoorPoint.airFlowHours
                  : indoorPointWinter.airFlowHours
              }*/
            value={
              summerWeather
                ? indoorPoint.airFlowHours
                : indoorPointWinter.airFlowHours
            }
            // onChange={handleIndoorPointChange}
            onChange={(e) => {
              setLocalIndoorAirflow(e.target.value);
            }}
            onBlur={handleIndoorPointChange}
            onKeyPress={handleKeyPress}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/*airflowUnit[chartConfig.airflowUnit]*/} m3/h
                </InputAdornment>
              ),
            }}
            //onChange={handleIndoorPointChange}
          />
        </Grid>

        <Grid item xs={12}></Grid>
      </Grid>
    </Paper>
  );
}

export default ControlPanelExcel;
